import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface VoiceNoteState {
  isOverlayClosed: boolean;
  isAudioDeleted: boolean;
}

const initialState: VoiceNoteState = {
  isOverlayClosed: true,
  isAudioDeleted: false,
};

const voiceNoteSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    setIsOverLayClosed: (state, action: PayloadAction<boolean>) => {
      state.isOverlayClosed = action.payload;
    },
    setIsAudioDeleted: (state, action: PayloadAction<boolean>) => {
      state.isAudioDeleted = action.payload;
    },
  },
});

export const { setIsOverLayClosed, setIsAudioDeleted } = voiceNoteSlice.actions;

export default voiceNoteSlice.reducer;
